<template>
  <div class="ai-friend-product-config">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit" @add="add" @delete="deleteRow"></ConfigTable>
    <EditProductConfig ref="editDialog" @sure="callEdit"></EditProductConfig>
  </div>
</template>

<script>
import { Switch } from 'element-ui';
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import aiFriendApi from '../../../api/aiFriendManage';
import EditProductConfig from './components/EditProductConfig.vue';
import { appOptions, getLabelTextWithValue, toggleOptions } from '../../config';

const searchConfig = [
  { type: 'select', placeholder: '选择App', key: 'appId', options: appOptions },
  { type: 'select', placeholder: '是否开启', key: 'status', options: toggleOptions },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
]
// PromptIntegral     int                json:"promptIntegral" bson:"promptIntegral"         // 提示词每百万价格
// CompletionInterval int                json:"completionInterval" bson:"completionInterval" // 完成词每百万价格
const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: 'App', key: 'appId', valueHandler: (val) => getLabelTextWithValue(appOptions, val) },
  { name: '产品域名', key: 'appUrl' },
  { name: '价格倍率（成本*n）', key: 'priceMultiple' },
  // { name: '提示词每百万价格', key: 'promptIntegral' },
  // { name: '完成词每百万价格', key: 'completionInterval' },
  {
    name: '状态', key: 'status', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiFriendProductConfig',
  components: { ConfigTable, EditProductConfig },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await aiFriendApi.getProductConfigList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai角色失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await aiFriendApi.delProductConfig({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit ? aiFriendApi.updateProductConfig(r.data) : aiFriendApi.createProductConfig(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {
        console.error('call edit error:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-product-config {

  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>